/**
 * How many recommendations each finder's Recommended tab asks the server for
 * (`Recommendations(kinds, RECOMMENDED_COUNT)`), mirroring the server setting
 * `research.recommend.count` (stage: 12). One constant for the three finders and
 * Home's tile, so the tile's "See N recommended" is the number the tab lists.
 */
export const RECOMMENDED_COUNT = 12;
